"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function TransitionableTransitionPopup(_ref) {
  var title = _ref.title,
    text = _ref.text,
    successMessage = _ref.successMessage,
    buttonText = _ref.buttonText,
    entity = _ref.entity,
    roleId = _ref.roleId,
    stageId = _ref.stageId,
    status = _ref.status,
    direction = _ref.direction,
    confirmed = _ref.confirmed,
    onUpdated = _ref.onUpdated,
    submit = _ref.submit,
    onClose = _ref.onClose;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var _useValidatedForm = (0, _commons.useValidatedForm)(false),
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register,
    isValid = _useValidatedForm.isValid;
  var buildRequest = (0, _react.useCallback)(function () {
    return Object.assign(Object.assign({}, bind()), {
      role_id: roleId,
      direction: direction,
      stage_id: stageId,
      status: status
    });
  }, [bind, roleId, stageId, status, direction]);
  var confirmTransition = (0, _react.useCallback)(function () {
    if (!isValid()) return;
    feedbackContext.showBackdrop();
    submit(buildRequest()).then(function (response) {
      feedbackContext.showSuccess(successMessage);
      onUpdated(response);
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  }, [feedbackContext, successMessage, buildRequest, isValid, onUpdated, submit]);
  (0, _react.useEffect)(function () {
    if (confirmed) {
      setTimeout(confirmTransition, 1500);
    }
  }, [confirmed, confirmTransition]);
  if (confirmed) {
    return /*#__PURE__*/_react["default"].createElement(_material.Hidden, {
      xsUp: true,
      implementation: "css"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      onLoad: confirmTransition
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: title,
    onClose: onClose,
    button: {
      text: buttonText !== null && buttonText !== void 0 ? buttonText : (0, _core.translate)('buttons.continue'),
      onClick: confirmTransition
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, text), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    name: "comments",
    type: "text",
    rows: 3,
    label: (0, _core.translate)("".concat(entity, ".transition.comments")),
    required: direction === 'BACKWARD',
    register: register
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(TransitionableTransitionPopup);